import { SettingsCache } from '~/lib/consts/settings-cache';
import ActionMenu from '../ActionMenu';
import Downloads from '../downloads/Downloads';
import ImportStatus from '../importstatus/ImportStatus';
import SearchTrigger from '../search/SearchTrigger';
import { P2GGrid, P2GLink } from '@parcel2go/core-ui';
import PrePayQuickList from '~/apps/prepay/prepay-quick-list';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { Suspense } from 'react';
import { TariffSelector } from '../customs/TariffSelector';

interface props {
  isXs: boolean;
  showSmartSendFeatures?: boolean;
  showNav?: boolean;
  currentPageRoute: string;
}

export default function DashActions({ isXs, showSmartSendFeatures, showNav, currentPageRoute }: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  return (
    <Suspense>
      <P2GGrid
        container
        spacing={2}
        alignContent="center"
        alignItems="center"
        classNames="dash-smartsend-actions dash-actions"
      >
        {!isXs && (
          <>
            {showSmartSendFeatures && (
              <>
                <P2GGrid item flexShrink={1}>
                  <ImportStatus />
                </P2GGrid>
                {SettingsCache.settings.Features.includes('QuickLink:Downloads') && (
                  <P2GGrid item flexShrink={1}>
                    <Downloads label={t('SUBNAV_DOWNLOADS_BUTTON', { defaultValue: 'Downloads' })} />
                  </P2GGrid>
                )}
              </>
            )}
            {SettingsCache.settings.Features.includes('PrePay') && (
              <P2GGrid item flexShrink={1}>
                <PrePayQuickList label={t('SUBNAV_PREPAY_BUTTON', { defaultValue: 'PrePay' })} />
              </P2GGrid>
            )}
            <P2GGrid item flexShrink={1}>
              <TariffSelector
                title={t('SUBNAV_TARIFF_CODE_BUTTON', { defaultValue: 'Tariff Codes' })}
                default="SEARCH"
                options={['SEARCH', 'BROWSE']}
                control={<P2GLink>{t('SUBNAV_TARIFF_CODE_BUTTON', { defaultValue: 'Tariff Codes' })}</P2GLink>}
                searchTerm="Apple iPad"
                system="HS"
                tariffCode={''}
                selectCode={null}
                canSelect={false}
              />
            </P2GGrid>
            {SettingsCache.settings.Features.includes('Search') && (
              <P2GGrid item flexShrink={1}>
                <SearchTrigger label={t('SUBNAV_ORDER_SEARCH_BUTTON', { defaultValue: 'Order Search' })} />
              </P2GGrid>
            )}
          </>
        )}
        {showNav && (
          <P2GGrid item flexShrink={1}>
            <ActionMenu isXs={isXs} currentPageRoute={currentPageRoute} />
          </P2GGrid>
        )}
      </P2GGrid>
    </Suspense>
  );
}
